import { IAuthProvider, IUser, UserRole } from './IAuthProvider';

/**
 * Static auth provider for SPFx local-dev mode and tests.
 * Returns a fixed admin user without contacting any backend.
 */
export class MockAuthProvider implements IAuthProvider {
  readonly supportsLogin = false;

  constructor(private user: IUser = {
    id: 'dev-admin',
    email: 'dev@local',
    displayName: 'Dev Admin',
    role: 'admin',
  }) {}

  getCurrentUser(): Promise<IUser | null> { return Promise.resolve(this.user); }

  async hasRole(role: UserRole): Promise<boolean> {
    if (role === 'admin') return this.user.role === 'admin';
    if (role === 'client') return this.user.role === 'admin' || this.user.role === 'client';
    return true;
  }
}
